<template>
  <section>
    <div class="icons-container">
      <div class="icon-3d icon-1" data-speed=".2">
        <img :src="ts" alt="3d" />
      </div>
      <div class="icon-3d icon-2" data-speed=".3">
        <img :src="nest" alt="3d" />
      </div>
      <!-- <div class="icon-3d icon-3">
        <img :src="folder" alt="3d" />
      </div> -->
      <div class="icon-3d icon-4" data-speed=".4">
        <img :src="vue" alt="3d" />
      </div>
      <div class="icon-3d icon-6" data-speed=".5">
        <img :src="tailwind" alt="3d" />
      </div>
      <div class="icon-3d icon-7" data-speed=".6">
        <img :src="vscode" alt="3d" />
      </div>
    </div>
    <div ref="home"></div>
    <div class="home__container">
      <div class="home-container">
        <div class="home__data">
          <div class="details__home">
            <span data-aos="zoom-in" data-aos-delay="200">Hi ! I'm,</span>
            <h1
              class="home__name title"
              translate="no"
              data-aos="zoom-in"
              data-aos-delay="300"
            >
              <div class="span-title t1">
                <span style="transition-delay: 0s">L</span
                ><span style="transition-delay: 0.1s">o</span
                ><span style="transition-delay: 0.2s">ï</span
                ><span style="transition-delay: 0.30000000000000004s">c</span
                ><span style="transition-delay: 0.4s"></span
                ><span style="transition-delay: 0.5s">F</span
                ><span style="transition-delay: 0.6000000000000001s">a</span
                ><span style="transition-delay: 0.7000000000000001s">r</span
                ><span style="transition-delay: 0.8s">e</span
                ><span style="transition-delay: 0.9s">l</span>
              </div>
              <div class="span-title t2">
                <span style="transition-delay: 0s">L</span
                ><span style="transition-delay: 0.1s">o</span
                ><span style="transition-delay: 0.2s">ï</span
                ><span style="transition-delay: 0.30000000000000004s">c</span
                ><span style="transition-delay: 0.4s"></span
                ><span style="transition-delay: 0.5s">F</span
                ><span style="transition-delay: 0.6000000000000001s">a</span
                ><span style="transition-delay: 0.7000000000000001s">r</span
                ><span style="transition-delay: 0.8s">e</span
                ><span style="transition-delay: 0.9s">l</span>
              </div>
            </h1>
            <p
              class="home__education dev_web"
              data-aos="zoom-in"
              data-aos-delay="400"
            >
              Web Developer
            </p>
            <div>
              <p
                class="home__education"
                data-aos="zoom-in"
                data-aos-delay="500"
              >
                My goal is to create high-performing, responsive, and functional
                websites and web applications for an excellent user experience.
              </p>
              <p
                class="home__education"
                data-aos="zoom-in"
                data-aos-delay="600"
              >
                I also produce music as a hobby.
              </p>
            </div>
            <ul class="profile__social">
              <li data-aos="fade-up" data-aos-delay="400">
                <a
                  href="https://www.linkedin.com/in/loicfarele"
                  target="_blank"
                  class="profile__social-link"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    fill="currentColor"
                    class="bi bi-linkedin"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z"
                    />
                  </svg>
                </a>
              </li>
              <li data-aos="fade-up" data-aos-delay="600">
                <a
                  href="https://www.twitter.com/loicfarel"
                  target="_blank"
                  class="profile__social-link"
                >
                  <svg
                    width="25"
                    height="25"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <g>
                      <path
                        d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
                      ></path>
                    </g>
                  </svg>
                </a>
              </li>
              <li data-aos="fade-up" data-aos-delay="600">
                <a
                  href="https://bento.me/loicfarel"
                  target="_blank"
                  class="profile__social-link"
                >
                  <svg
                    enable-background="new 0 0 24 24"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="m0 0h24v24h-24z" fill="none" />
                    <path
                      d="m16 11v-6h6v6zm0 8h6v-6h-6zm-2-14v14h-12v-14zm-4.5 7c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5.67 1.5 1.5 1.5 1.5-.67 1.5-1.5z"
                    />
                  </svg>
                </a>
              </li>
              <li data-aos="fade-up" data-aos-delay="500">
                <a
                  href="mailto:loicfarele@gmail.com"
                  target="_blank"
                  class="profile__social-link"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="m18.73 5.41-1.28 1L12 10.46 6.55 6.37l-1.28-1A2 2 0 0 0 2 7.05v11.59A1.36 1.36 0 0 0 3.36 20h3.19v-7.72L12 16.37l5.45-4.09V20h3.19A1.36 1.36 0 0 0 22 18.64V7.05a2 2 0 0 0-3.27-1.64z"
                    ></path>
                  </svg>
                </a>
              </li>
              <li data-aos="fade-up" data-aos-delay="700">
                <a
                  href="https://github.com/loicfarel"
                  target="_blank"
                  class="profile__social-link"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M12.026 2c-5.509 0-9.974 4.465-9.974 9.974 0 4.406 2.857 8.145 6.821 9.465.499.09.679-.217.679-.481 0-.237-.008-.865-.011-1.696-2.775.602-3.361-1.338-3.361-1.338-.452-1.152-1.107-1.459-1.107-1.459-.905-.619.069-.605.069-.605 1.002.07 1.527 1.028 1.527 1.028.89 1.524 2.336 1.084 2.902.829.091-.645.351-1.085.635-1.334-2.214-.251-4.542-1.107-4.542-4.93 0-1.087.389-1.979 1.024-2.675-.101-.253-.446-1.268.099-2.64 0 0 .837-.269 2.742 1.021a9.582 9.582 0 0 1 2.496-.336 9.554 9.554 0 0 1 2.496.336c1.906-1.291 2.742-1.021 2.742-1.021.545 1.372.203 2.387.099 2.64.64.696 1.024 1.587 1.024 2.675 0 3.833-2.33 4.675-4.552 4.922.355.308.675.916.675 1.846 0 1.334-.012 2.41-.012 2.737 0 .267.178.577.687.479C19.146 20.115 22 16.379 22 11.974 22 6.465 17.535 2 12.026 2z"
                    ></path>
                  </svg>
                </a>
              </li>
            </ul>
          </div>

          <div
            class="profile__border"
            data-aos="fade-right"
            data-aos-delay="500"
          >
            <img :src="img_profil" alt="" class="profile__pic" />
          </div>
        </div>
      </div>
      <div class="home__buttons" data-aos="fade-up" data-aos-delay="500">
        <!-- <router-link to="/" class="button">Explore </router-link> -->
        <button-explore @click="scrollToSection('about')"></button-explore>
      </div>
      <div ref="about"></div>
    </div>
  </section>
  <about-page></about-page>
  <div ref="projet"></div>
  <last-projets></last-projets>
  <HeaderBottom @move="scrollToSection" />
</template>
<script>
import LastProjets from "@/components/LastProjets.vue";
import AboutPage from "@/components/AboutPage.vue";
import ButtonExplore from "@/components/ButtonExplore.vue";
import HeaderBottom from "@/components/HeaderBottom.vue";
export default {
  components: {
    LastProjets,
    AboutPage,
    ButtonExplore,
    HeaderBottom,
  },

  data() {
    return {
      img_profil: require("../assets/img/about.png"),
      nest: require("../assets/img/icons/nestjs.png"),
      vue: require("../assets/img/icons/vuejs.png"),
      tailwind: require("../assets/img/icons/tailwind.png"),
      ts: require("../assets/img/icons/typescript.png"),
      vscode: require("../assets/img/icons/visual-studio-code.png"),
      rocket: require("../assets/img/icons/rocket-dynamic-color.png"),
      folder: require("../assets/img/icons/folder-dynamic-color.png"),
    };
  },

  methods: {
    scrollToSection(section) {
      this.$refs[section].scrollIntoView({ behavior: "smooth" });
    },
  },
};
</script>
<style scoped>
section {
  position: relative;
}
.icons-container {
  position: absolute;
  width: 100dvw;
  height: 100dvh;
  z-index: 2;
  opacity: 0.2;
  display: none;
}

.icon-3d {
  width: 50px;
  height: 50px;
  position: absolute;
}

@media screen and (max-width: 900px) {
  .icon-3d {
    width: 40px;
    height: 40px;
  }
}

.icon-1 {
  top: 12%;
  left: 8%;
}
.icon-2 {
  top: 70%;
  left: 2%;
}
.icon-4 {
  top: 10%;
  left: 48%;
}
.icon-6 {
  top: 12%;
  left: 88%;
}
.icon-7 {
  top: 70%;
  left: 95%;
}

.home__container {
  position: relative;

  width: 100vw;
  height: 100vh;
  z-index: 20;
}

.home-container {
  width: 100%;
  height: 86%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.home__data {
  width: 100%;
  display: flex;
  justify-content: space-around;
  margin: auto;
  align-items: center;
  padding: 0 16px;
}

/* Animmation text */
.title {
  position: relative;
}

.title span {
  font-size: 50px;
  transition: 0.4s;
  font-weight: 600;
  will-change: transform;
  display: inline-block;
  color: var(--title-color);
}

.t1 span {
  transform-origin: bottom;
}

.t2 span {
  transform-origin: top;
  transform: translateY(100%) rotateX(-90deg);
}

.t2 {
  position: absolute;
  top: 0;
  left: 0;
}

.title:hover .t1 span {
  transform: translateY(-100%) rotateX(-90deg);
  color: var(--text-color);
}

.title:hover .t2 span {
  transform: translateY(0%) rotateX(0deg);
  color: var(--first-color);
}

.home__greeting {
  display: block;
  color: var(--title-color);
  margin-bottom: 0.25rem;
}

.home__education {
  width: 100%;
  color: var(--text-color);
  margin-bottom: 1rem;
  font-size: var(--h1-font-size);
  font-weight: var(--font-medium);
}

.dev_web {
  font-weight: var(--font-semibold);
  transition: all 0.3s;
}

.home__name {
  font-size: var(--biggest-font-size);
}

.details__home {
  max-width: 600px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/*===============Profile ===============*/
.profile__data {
  display: grid;
  text-align: center;
}

.profile__pic {
  width: 250px;
  height: 250px;
  object-fit: contain;
  overflow: hidden;
  display: flex;
  align-items: center;
  /* align-items: flex-end; */
  padding-right: 2rem;
  justify-content: center;
}

.profile__pic img {
  width: auto;
}

.profile__border {
  width: 135px;
  height: 135px;
  display: grid;
  place-items: center;
  transform-style: preserve-3d;
  /* animation: profile 3s cubic-bezier(1, 0.5, 0.6, 0.7); */
}

.profile__social li a {
  position: relative;
  display: flex;
  width: 50px;
  height: 50px;
  align-items: center;
  justify-content: center;
  line-height: 20px;
  border-radius: 50%;
  font-size: 10px;
  transition: 0.3s;
  box-shadow: 0 0 5px var(--first-color);
}

.profile__social li a::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  transition: 0.3s;
  transform: scale(0.9);
  z-index: -1;
}

.profile__social li a:hover::before {
  transform: scale(1.1);
  box-shadow: 0 0 15px var(--first-color);
}

.profile__social li a:hover svg {
  fill: var(--first-color);
}

.profile__social li a:hover {
  color: var(--first-color);
  text-shadow: 0 0 5px var(--first-color);
}

@keyframes profile {
  100% {
    transform: rotate3d(0, 1, 0, 360deg);
  }
}

/* @keyframes details{
    from {
    opacity: 0;
  }

  to {
    opacity: 1;
    transform: none;
  }

} */

/* .home{
  animation: details .3s ease-in-out;
} */

/* .profile__border:hover {
  animation: profile 14s infinite cubic-bezier(0.4, 0.6, 0.3, 0.4);
} */

.profile__social {
  display: flex;
  /* justify-content: center; */
  column-gap: 0.9rem;
  margin-bottom: 1.5rem;
}

.profile__social-link svg {
  /* display: none; */
  fill: var(--title-color);
  transition: 0.3s;
}

.profile__social-link svg:hover {
  fill: var(--first-color);
}

.profile__social-link {
  font-size: 1.25rem;
  color: var(--title-color);
  transition: 0.3s;
}

.profile__social-link:hover {
  color: var(--first-color);
}

/*=============== End Profile ===============*/

.home__buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1.5rem;
}

@media screen and (max-width: 320px) {
  .home__container {
    width: auto;
    height: auto;
    margin-top: 100px;
  }

  .title span {
    font-size: 30px;
  }
}

@media screen and (min-width: 900px) {
  .home__data {
    width: 100%;
    display: flex;
    gap: 10px;
    align-items: center;
  }

  .title span {
    font-size: 80px;
  }

  .profile__social li a {
    width: 60px;
    height: 60px;
    line-height: 63px;
    font-size: 30px;
  }

  .profile__social-link {
    font-size: 2.25rem;
  }

  .profile__social {
    column-gap: 1.75rem;
  }

  .profile__pic {
    width: 420px;
    height: 420px;
    transition: filter 0.4s;
  }
  .profile__pic:hover {
    filter: saturate(0%);
  }

  .profile__border {
    width: 435px;
    height: 435px;
  }

  .profile__pic img {
    width: 145px;
  }

  .logo span {
    font-size: 7rem;
  }

  .home__education {
    font-size: 25px;
  }

  .icons-container {
    display: block;
  }
}

@media screen and (max-width: 900px) {
  .profile__border {
    display: none;
  }
}

@media screen and (max-width: 1090px) {
  .profile__pic {
    width: 300px;
    height: 300px;
  }

  .profile__border {
    width: 305px;
    height: 305px;
  }
}
</style>
